import React from 'react';
import { solutionMetrics, coverage, images } from '../data/content';
export function SolutionSection() {
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-211" data-mp="3aaklvsc4l49q">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-212" data-mp="3o90phaeoyenn">
        <div className="grid items-center gap-12 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-213" data-mp="3oalnxb44mhqs">
          <div data-id="element-214" data-mp="3j8mlc3g7nouw">
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-215" data-mp="3jcae30du078k">
              The most complete system for academy directors
            </p>
            <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight text-white sm:text-6xl" data-id="element-216" data-mp="3t7ludn4w1mif">
              The Total Academy System&trade;
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-217" data-mp="5wm5wfrwi25e">
              Over 240 pages of complete session plans, professional 11v11
              drills, periodization phases, and staff management tools — all
              already prepared for you. This isn&rsquo;t a book of drills. It is
              a coaching blueprint taken from the methodologies of top European
              academies.
            </p>

            <dl className="mt-10 grid grid-cols-2 gap-px overflow-hidden border border-line bg-line sm:grid-cols-4" data-id="element-218" data-mp="3fbae862miebk">
              {solutionMetrics.map(metric => <div key={metric.unit} className="bg-panel px-4 py-6" data-id="element-219" data-mp="3kboo7tnsbyc8">
                  <dt className="sr-only" data-id="element-220" data-mp="3p8f5ulf8n1zr">{metric.unit}</dt>
                  <dd data-id="element-221" data-mp="3u8kzg752iykh">
                    <span className="block font-display text-3xl font-extrabold leading-none text-acid sm:text-4xl" data-id="element-222" data-mp="3u7rpyyeq5uyn">
                      {metric.value}
                    </span>
                    <span className="mt-2 block text-[11px] font-semibold uppercase leading-snug tracking-[0.12em] text-white/45" data-id="element-223" data-mp="6v8y3116ju19">
                      {metric.unit}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>

          <img src={images.manual} alt="Cover of The Total Academy System: The Professional Curriculum for Elite Youth Development" className="w-full border border-line object-cover" loading="lazy" data-id="element-224" data-mp="grc1093uvwp9" />
        </div>

        <div className="mt-16 border-t border-line pt-12" data-id="element-225" data-mp="2mnxgsd8c2zvk">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-226" data-mp="2hvmgvadlfe30">
            Total coverage
          </p>
          <h3 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl" data-id="element-227" data-mp="2vlpz7q9cqnn6">
            Every phase of an 11v11 season, U12 through U19
          </h3>

          <ol className="mt-8 grid gap-px overflow-hidden border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-228" data-mp="35k5rvxo124ys">
            {coverage.map((item, i) => <li key={item} className="flex items-baseline gap-4 bg-night px-6 py-5" data-id="element-229" data-mp="1b77g19moj09c" data-mpi={i}>
                <span className="font-display text-sm font-bold text-acid" data-id="element-230" data-mp="169o4ihhd91l3">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl" data-id="element-231" data-mp="3mut52avippms">
                  {item}
                </span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}